module.exports = __webpack_public_path__ + "static/media/apti_fidelis.756cc37b.jpg";